"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlaybackController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MediaPlaybackControls = require("./MediaPlaybackControls");
var _MediaPlaybackController = require("./MediaPlaybackController.styled");
var _constants = require("../../constants");
var _utils = require("../../utils");
var _VideoPlayerContext = require("../../contexts/VideoPlayerContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Controller = function Controller(_ref) {
  var type = _ref.type,
    onSeek = _ref.onSeek,
    options = _ref.options,
    settings = _ref.settings,
    onTogglePlay = _ref.onTogglePlay,
    isLight = _ref.isLight,
    defaultExt = _ref.defaultExt;
  var readOnly = options.readOnly;
  var ext = settings.ext || defaultExt;
  var title = settings.title;
  var computedTitle = (0, _react.useMemo)(function () {
    // this is necessary for backward compatibility.
    // it's not really required for new sources going forward as they won't have the extension
    // in the title.
    return (0, _utils.getSanitizedContentTitle)(title, ext);
  }, [title, ext]);
  return /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.ControllerWrapper, {
    className: "".concat(type, "-controller"),
    "data-testid": "".concat(type, "-controller")
  }, /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.Flex, null, /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledFileTitle, {
    isLight: isLight,
    readOnly: readOnly
  }, computedTitle)), /*#__PURE__*/_react["default"].createElement(_MediaPlaybackControls.MediaPlaybackControls, {
    onSeek: onSeek,
    onTogglePlay: onTogglePlay,
    settings: settings,
    type: type,
    isLight: isLight,
    readOnly: readOnly
  }));
};
var defaultOptions = {
  readOnly: false
};
var MediaPlaybackController = exports.MediaPlaybackController = function MediaPlaybackController(_ref2) {
  var onSeek = _ref2.onSeek,
    onTogglePlay = _ref2.onTogglePlay,
    _ref2$videoSettings = _ref2.videoSettings,
    videoSettings = _ref2$videoSettings === void 0 ? {} : _ref2$videoSettings,
    _ref2$audioSettings = _ref2.audioSettings,
    audioSettings = _ref2$audioSettings === void 0 ? {} : _ref2$audioSettings,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? defaultOptions : _ref2$options,
    isLight = _ref2.isLight;
  var _useContext = (0, _react.useContext)(_VideoPlayerContext.VideoPlayerContext),
    playersInitialized = _useContext.playersInitialized;
  return /*#__PURE__*/_react["default"].createElement("div", null, videoSettings._id && playersInitialized[videoSettings._id] && /*#__PURE__*/_react["default"].createElement(Controller, {
    onSeek: onSeek,
    options: options,
    type: _constants.VIDEO_FILE,
    settings: videoSettings,
    onTogglePlay: onTogglePlay,
    isLight: isLight,
    defaultExt: ".mp4"
  }), audioSettings._id && playersInitialized[audioSettings._id] && /*#__PURE__*/_react["default"].createElement(Controller, {
    onSeek: onSeek,
    options: options,
    type: _constants.AUDIO_FILE,
    settings: audioSettings,
    onTogglePlay: onTogglePlay,
    isLight: isLight,
    defaultExt: ".mp3"
  }));
};
Controller.propTypes = {
  type: _propTypes["default"].oneOf([_constants.AUDIO_FILE, _constants.VIDEO_FILE]),
  onSeek: _propTypes["default"].func,
  options: _propTypes["default"].shape({
    readOnly: _propTypes["default"].bool
  }),
  settings: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    ext: _propTypes["default"].string
  }),
  onTogglePlay: _propTypes["default"].func,
  isLight: _propTypes["default"].bool
};
MediaPlaybackController.propTypes = {
  onSeek: _propTypes["default"].func,
  onTogglePlay: _propTypes["default"].func,
  videoSettings: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    ext: _propTypes["default"].string
  }),
  audioSettings: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    ext: _propTypes["default"].string
  }),
  options: _propTypes["default"].shape({
    readOnly: _propTypes["default"].bool
  }),
  isLight: _propTypes["default"].bool
};